import { BlogComponent } from "../../../componets";
export default function BlogPage() {
  return <BlogComponent />;
}
